export const toastsIntlIds = {
  onLoadingToast: {
    title: 'toastsIntlIds.onLoadingToast.title',
    description: 'toastsIntlIds.onLoadingToast.description',
  },
};
